module.exports = __webpack_public_path__ + "static/ResumePaulo-259c5b16a870a5ea5513b0e9b9ec30cf.pdf";